import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { ApiService } from '../../services/api/api.service';
import { AlertError } from '../actions';
import { GetAggregationData, GetReconCardinalityCount, SetAggregationData, SetReconCardinalityCount } from '../actions/aggregation.actions';
import { getSearchCriteriaMap$ } from '../selectors';

@Injectable()
export class AggregationCountEffects {
    constructor(private actions$: Actions, private _api: ApiService, private store$: Store) {}

    getReconCardinalityCount$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GetReconCardinalityCount),
            mergeMap(action => {
                return from(this._api.records.getAggregations(action.criteria)).pipe(
                    map(response => {
                        return SetReconCardinalityCount({
                            instanceId: action.instanceId,
                            parentRecordId: action.parentRecordId,
                            fieldId: action.fieldId,
                            reconCardinalityCount: response?.aggregationResult?.aggregations[0]?.value,
                        });
                    }),
                    catchError(e => of(AlertError({ message: e })))
                );
            })
        )
    );

    getAggregationData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GetAggregationData),
            withLatestFrom(this.store$.select(getSearchCriteriaMap$)),
            mergeMap(([action, searchOrgMap]) => {
                const aggregationName = action.criteriaName;
                const criteria = searchOrgMap?.[action.serviceId]?.entities?.[aggregationName] || action?.criteria;
                return from(this._api.records.getAggregations(criteria)).pipe(
                    map(response => {
                        return SetAggregationData({
                            instanceId: action.instanceId,
                            parentRecordId: action.parentRecordId,
                            fieldId: action.fieldId,
                            aggregationResult: response?.aggregationResult?.aggregations,
                            from: action?.from,
                        });
                    }),
                    catchError(e => of(AlertError({ message: e })))
                );
            })
        )
    );
}
